// extracted by mini-css-extract-plugin
export default {"root":"ShiftRecord_root__MRVtE","icon":"ShiftRecord_icon__KeROU"};